import { Grid, Paper, SxProps, Typography } from '@mui/material';
import { colors } from 'remote/global';
import { DefaultTFuncReturn } from 'i18next';

function PaperLayout({
  children,
  title,
  subtitle,
  sx,
}: {
  children: React.ReactNode;
  title?: string | null;
  subtitle?: string | DefaultTFuncReturn;
  sx?: SxProps;
}) {
  return (
    <Paper elevation={3} sx={{ p: [3, 4], maxWidth: '400px', ...sx }}>
      <Grid container>
        <Grid item xs={12} mb={2}>
          {title != null && (
            <Typography
              sx={{
                color: colors.uiBlue600,
                fontWeight: 600,
                fontSize: '18px',
              }}
            >
              {title}
            </Typography>
          )}
          {subtitle != null && (
            <Typography
              sx={{
                color: colors.gray1,
              }}
              variant='body2'
            >
              {subtitle}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </Paper>
  );
}

export default PaperLayout;
